import {routerReducer} from '@ngrx/router-store';

// State
import {AppReducer} from './app-reducer';
import {CatalogReducer} from '../../catalog/shared/state/catalog-reducer';

export const AppReducers = {
    router: routerReducer,
    app: AppReducer,
    catalog: CatalogReducer,
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/state/app-reducers.ts